export default {
    init(selector, config) {
      // JavaScript to be fired on the download resources page
  
    },
    finalize() {

      $("#statediv").addClass('d-none');
      $("#postcodediv").addClass('d-none');
      // JavaScript to be fired on the home page, after the init JS
      const occupation_value = $('#occupation').val();
      if(occupation_value == 'other (occupation not listed)'){
        $(".occupation_others_div").removeClass('d-none');
      }
      // Show selected occupation categories
      $('#occupation').on('change', function () {
        const occupation_value = $(this).val(); // get the dropdown value
        $(".occupation_others_div").addClass('d-none'); // by default others field hide
        //BIZ_823 START: Making occupation_others element null only if profilevalidation
        var profileValidationClick = $(".profileValidation");
        if(!profileValidationClick.data('clicked')) {
          $("#occupation_others").val('');
        }
        //BIZ_823 START: Making occupation_others element null only if profilevalidation
        if(occupation_value == 'other (occupation not listed)'){
          $(".occupation_others_div").removeClass('d-none');
        }
      });

      $('#countryselect').on('change', function () {
        const country_value = $(this).val();
        if(country_value != "Australia"){
          $("#statediv").addClass('d-none');
          $('#state option').each(function() {

            if ( $(this).val() == '' ) {
                $(this).prop('selected', true);
            }else { 
                $(this).prop('selected', false);
            }  

          });
          $('#state').data('rule-required',false);
          $("#postcodediv").addClass('d-none');
          $("#postcodeb").val('');
          $('#postcodeb').data('rule-required',false);
        }else{
          $("#statediv").removeClass('d-none');
          $("#postcodediv").removeClass('d-none');
          $('#state').data('rule-required',true);
          $('#postcodeb').data('rule-required',true);
        }
      });
  
    },
  };



// WEBPACK FOOTER //
// ./scripts/routes/download-resources-files.js